import { endsWith, startsWith } from '@dazn/bootstrap-lib';

const ensureTrailingSlash = (url: string) => {
    if (endsWith(url, '/')) {
        return url;
    }

    return `${url}/`;
};

const ensureLeadingSlash = (url: string) => {
    if (startsWith(url, '/')) {
        return url;
    }

    return `/${url}`;
};

export { ensureTrailingSlash, ensureLeadingSlash };
